module.exports = __webpack_public_path__ + "static/sorcerer_storm_human_male_scag-563584960917eafdf6dc05942b7046e4.webp";